import { z } from 'zod';


export const registerAttendanceFormSchema = z.object({
  fecha: z.string().min(1, 'attendance:validation.dateRequired'),
  hora: z.string().min(1, 'attendance:validation.timeRequired'),
  ubicacion: z.string().min(1, 'attendance:validation.locationRequired'),
});

export type RegisterAttendanceFormValues = z.infer<typeof registerAttendanceFormSchema>;
